import { Body, Box, Container, Heading } from '@hover/blueprint';
import { ButtonProps } from '@hover/blueprint/brand';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { ArrowButton } from '@hover/shared-components';
import CareersHeroVector from '../../assets/svgs/CareersHeroVector';

const CareerHero: React.FC = () => {
  const onOpenRolesClick: ButtonProps['onClick'] = event => {
    if (!(event.currentTarget instanceof HTMLAnchorElement)) return;

    const { hash } = new URL(event.currentTarget.href);
    const element = document.querySelector(hash);

    if (!element) return;

    event.preventDefault();

    element.scrollIntoView({
      behavior: 'chrome' in window ? undefined : 'smooth',
    });

    window.history.pushState(null, document.title, hash);
  };

  return (
    <Box
      w="100%"
      bg="brandNavy.500"
      height={{ base: 'auto', desktop: '621px' }}
      overflow="hidden"
      alignItems="center"
      pt={{ base: 700, desktop: 0 }}
      pb={{ base: 1000, desktop: 0 }}
    >
      <Container maxW="1232px" px={200}>
        <Box
          alignItems="center"
          justifyContent="space-between"
          flexDir={{ base: 'column', desktop: 'row' }}
        >
          <Container
            maxW={{ base: '3xl', desktop: '700px' }}
            display="flex"
            flexDirection="column"
            alignItems={{ base: 'center', desktop: 'start' }}
          >
            <Heading
              size={{ base: 600, tablet: 700, desktop: 800 }}
              style={{ marginBottom: 0, color: 'white', fontWeight: 700 }}
              textAlign={{ base: 'center', desktop: 'left' }}
            >
              Homeownership can be hard. Let’s change that!
            </Heading>
            <Body
              maxW={{ base: '100%', desktop: 'lg' }}
              mt={500}
              mb={700}
              size={500}
              color="neutral.0"
              textAlign={{ base: 'center', desktop: 'left' }}
            >
              HOVER is unlocking the potential of every property with our
              patented 3D technology. We’re looking for creative thinkers and
              doers to join our team. Let’s make home improvement better for
              everyone.
            </Body>
            <ArrowButton
              as="a"
              display="inline-flex"
              href="/careers#open-roles"
              onClick={onOpenRolesClick}
              colorScheme="brandNavy"
              variant="inverted"
              justifyContent="center"
              width={{ base: '323px', desktop: 'auto' }}
            >
              View open roles
            </ArrowButton>
          </Container>
          <Box
            d={{ base: 'none', tablet: 'flex' }}
            w="100%"
            maxW="450px"
            mt="72px"
          >
            <Box position="relative" w="100%" justifyContent="flex-end">
              <CareersHeroVector />
              <Box
                maxWidth="417px"
                w="100%"
                position="absolute"
                top="52px"
                right="38px"
              >
                <StaticImage
                  loading="eager"
                  placeholder="blurred"
                  src="../../assets/images/careers_hero_separate.png"
                  alt="careers hero vector"
                  objectFit="contain"
                />
              </Box>
            </Box>
          </Box>
          <Container
            d={{ base: 'flex', tablet: 'none' }}
            mt="72px"
            maxW="450px"
            px={500}
          >
            <StaticImage
              loading="eager"
              placeholder="blurred"
              src="../../assets/images/careers_hero.png"
              alt="careers hero vector"
              width={450}
            />
          </Container>
        </Box>
      </Container>
    </Box>
  );
};

export default CareerHero;
